// extracted by mini-css-extract-plugin
export default {"modalBody":"spinner-modal__modal-body__2Z2kY"};